module.exports = __webpack_public_path__ + "img/baby-room.ac186a48.svg";